import { useProtectedAPI } from "./apiService";
import { objectToQueryString } from "@/utils/objectToQueryString";
import useSWR from "swr";


export const useAdminGetRolesDefinitionsSWR = () => {
    const protectedAPI = useProtectedAPI();
    const fetcher = (url) => protectedAPI.get(url).then((res) => res.data);

    const { data, error, isLoading, isValidating, mutate } = useSWR("/admin/roles_definitions", fetcher);

    return {
        data,
        error,
        isLoading,
        isValidating,
        callToAction: mutate,
    };
}



export const useAdminGetRole = () => {
    const protectedAPI = useProtectedAPI();

    const adminGetRole = async (id) => {
        const response = await protectedAPI.get(`/admin/role/${id}`)
        return response.data
    }

    return adminGetRole
}



export const useAdminGetRolesSWR = () => {
    const protectedAPI = useProtectedAPI();
    const fetcher = (url) => protectedAPI.get(url).then((res) => res.data);

    const { data, error, isLoading, isValidating, mutate } = useSWR("/admin/roles", fetcher);

    return {
        data,
        error,
        isLoading,
        isValidating,
        callToAction: mutate,
    };
}

export const useAdminGetRoles = () => {
    const protectedAPI = useProtectedAPI();

    const adminGetRoles = (filters) => {
        const queryString = objectToQueryString(filters)
        const url = `/admin/roles?${queryString}`
        const promise = protectedAPI.get(url).then(response => {
            return {
                data: response.data,
                total: response.headers["x-total-count"]
            }
        })

        return {
            then: (resolve, reject) =>
                promise.then(result => resolve(result.data), reject),
            catch: (reject) =>
                promise.catch(reject),
            withTotal: () =>
                promise.then(result => [result.data, result.total])
        }

    }
    
    return adminGetRoles
}



export const useAdminGetRightsSWR = () => {
    const protectedAPI = useProtectedAPI();
    const fetcher = (url) => protectedAPI.get(url).then((res) => res.data);

    const { data, error, isLoading, isValidating, mutate } = useSWR("/admin/rights", fetcher);

    return {
        data,
        error,
        isLoading,
        isValidating,
        callToAction: mutate,
    };
}



export const useAdminCreateRole = () => {
    const protectedAPI = useProtectedAPI();

    const adminCreateRole = async (data) => {

        if (typeof data.skill_id == 'string' && data.skill_id == '')
            data.skill_id = null
        if (typeof data.competition_id == 'string' && data.competition_id == '')
            data.competition_id = null

        const response = await protectedAPI.post(`/admin/role`, data)
        return response.data
    };

    return adminCreateRole;
}



export const useAdminUpdateRole = () => {
    const protectedAPI = useProtectedAPI();

    const useAdminUpdateRole = async (id, data) => {

        if (typeof data.skill_id == 'string' && data.skill_id == '')
            data.skill_id = null
        if (typeof data.competition_id == 'string' && data.competition_id == '')
            data.competition_id = null

        const response = await protectedAPI.put(`/admin/role/${id}`, data)
        return response.data
    };

    return useAdminUpdateRole;
}



export const useAdminDeleteRole = () => {
    const protectedAPI = useProtectedAPI();

    const useAdminDeleteRole = async (id) => {
        const response = await protectedAPI.delete(`/admin/role/${id}`)
        return response.data
    };

    return useAdminDeleteRole;
}
